;(function($) {
    $(document).ready(
        function() {
            // $('#single-read-more').on('click', function(e) {
            //     $('#single-excerpt').fadeOut('fast');
            //     $(this).fadeOut('fast');
        
            //     if ( $('#single-content').is('.d-none') ) {
            //         $('#single-content').hide();
            //         $('#single-content').removeClass('d-none');
            //         $('#single-content').fadeIn('slow');
            //     }
            // });
        
            var $table_orderable = $('.table.orderable');
            if ( $table_orderable.length > 0 ) {
                $table_orderable.each(
                    function(i, ele) {
                        $('[data-link]').click(
                            function(e) {
                                location.href = $(this).data('link');

                                return e.preventDefault();
                            }
                        );
                        $('.table-header-cell', ele).each(
                            function(i, ele) {
                                var column_index = i;
                                if ( $(ele).is('.sortable') ) {
                                    $(ele).click(
                                        function(e) {
                                            var sorter = null;
                                            var is_sortable = $(this).is('.sortable');
                                            var is_sort_asc = $(this).is('.sort_asc');
                                            var is_sort_desc = $(this).is('.sort_desc');

                                            if ( ! is_sort_asc && ! is_sort_desc ) {
                                                is_sort_desc = true;
                                            }

                                            function sort_asc(a,b){
                                                var row_a = jQuery(a).data('row');
                                                var row_b = jQuery(b).data('row');
                                                var value_a = row_a[column_index] != null ? row_a[column_index] : '';
                                                var value_b = row_b[column_index] != null ? row_b[column_index] : '';
                                                return value_a.localeCompare(value_b);
                                            }

                                            function sort_desc(a,b){
                                                var row_a = jQuery(a).data('row');
                                                var row_b = jQuery(b).data('row');
                                                var value_a = row_a[column_index] != null ? row_a[column_index] : '';
                                                var value_b = row_b[column_index] != null ? row_b[column_index] : '';
                                                return value_b.localeCompare(value_a);
                                            }

                                            $(this).siblings().removeClass('sort_asc');
                                            $(this).siblings().removeClass('sort_desc');

                                            if ( is_sortable && is_sort_asc ) {
                                                sorter = sort_desc;
                                                $(this).removeClass('sort_asc');
                                                $(this).addClass('sort_desc');
                                            }

                                            if ( is_sortable && is_sort_desc ) {
                                                sorter = sort_asc;
                                                $(this).removeClass('sort_desc');
                                                $(this).addClass('sort_asc');
                                            }


                                            jQuery('.table-row','.table-body').sort(sorter)
                                            .each(
                                                function(i,ele){
                                                    jQuery('.table-body').append(ele);
                                                }
                                            );
        
                                            return e.preventDefault();
                                        }
                                    );
                                }
                            }
                        );
                    }
                );
            }

            var $collapsible = $('.collapsible');
            $collapsible.each(
                function(i, ele) {
                    $(ele).parent().click(
                        function(e) {
                            $(this).parent().siblings().each(
                                function(i, ele) {
                                    var $element = $('.collapsible', ele);
                                    $element.animate(
                                        {height: '0px'},
                                        {
                                            start: function() {
                                            },
                                            complete: function() {
                                                $element.addClass('collapsed');
                                            }
                                        }
                                    );
                                }
                            );
                            var $element = $('.collapsible', this);
                            var $child = $element.children().first();
                            var parent_hash = $(this).parent().attr('id');

                            if ( $element.is('.collapsed') ) {
                                $element.animate(
                                    {height: $child.height() + 'px'},
                                    {
                                        start: function() {
                                            $element.removeClass('collapsed');
                                        },
                                        complete: function() {
                                            $element.css('height', '');
                                        },
                                        done: function() {
                                            location.hash = parent_hash;
                                        }
                                    }
                                );
                            } else {
                                $element.animate(
                                    {height: '0px'},
                                    {
                                        start: function() {
                                        },
                                        complete: function() {
                                            $element.addClass('collapsed');
                                        }
                                    }
                                );
                            }
                            return e.preventDefault();
                        }
                    );
                }
            );
        }
    );
})(jQuery.noConflict());
